import { Box, Flex, useColorMode } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { generatePath, Link } from "react-router-dom";
import InfiniteScroll from "../../DSL/InfiniteScroll/InfiniteScroll";
import Pane from "../../DSL/Pane/Pane";
import { lightOrDarkMode } from "../../DSL/Theme";
import Typography, { TVariant } from "../../DSL/Typography/Typography";
import AppStore from "../../store/App.store";
import LeaderborkStore, { SelectedOwnerTab } from "./Leaderbork.store";
import UserCard from "./UserCard";

const TABS: { key: 'v3' | 'v1'; label: string; network: string }[] = [
  { key: 'v3', label: 'V3 Holders', network: 'Base L2' },
  { key: 'v1', label: 'V1 Holders', network: 'Ethereum L1' },
];

const TopDogs = observer(({ store }: { store: LeaderborkStore }) => {
  const { colorMode } = useColorMode();
  const activeTab = TABS.find(t => t.key === store.leaderboardChain)!;
  return (
    <Box>
      <Flex mb={2} gap={6}>
        {TABS.map(tab => (
          <Typography
            key={tab.key}
            variant={TVariant.PresStart12}
            onClick={() => store.setLeaderboardChain(tab.key)}
            cursor={"pointer"}
            pb={1}
            borderBottom={"2px solid"}
            borderColor={
              store.leaderboardChain === tab.key
                ? lightOrDarkMode(colorMode, "yellow.100", "gray.100")
                : "transparent"
            }
            color={
              store.leaderboardChain === tab.key
                ? lightOrDarkMode(colorMode, "yellow.100", "gray.100")
                : lightOrDarkMode(colorMode, "gray.500", "gray.500")
            }
            _hover={{ color: lightOrDarkMode(colorMode, "yellow.100", "gray.300") }}
          >
            {tab.label}
          </Typography>
        ))}
      </Flex>
      <Pane
        display={"flex"}
        flexDirection={"column"}
        title={
          <Flex alignItems={"center"} justifyContent={"space-between"} w={"full"}>
            <Flex alignItems={"center"} flexShrink={0} mr={2}>
              <Typography variant={TVariant.PresStart18} block height={"max-content"} whiteSpace={"nowrap"}>
                Top Dogs
              </Typography>
              <Typography
                variant={TVariant.PresStart14}
                ml={3}
                height={"max-content"}
                block
                color={lightOrDarkMode(colorMode, "yellow.100", "gray.300")}
                whiteSpace={"nowrap"}
              >
                ({store.activeLeaderboardOwners.length})
              </Typography>
            </Flex>
            <Typography
              variant={TVariant.PresStart10}
              color={lightOrDarkMode(colorMode, "yellow.100", "gray.400")}
              height={"max-content"}
              whiteSpace={"nowrap"}
              flexShrink={0}
            >
              {activeTab.network}
            </Typography>
          </Flex>
        }
        h={{ xl: "full" }}
        maxH={{ base: "300px", lg: "full" }}
      >
        <Box overflowY={"auto"} flexGrow={1}>
          <Flex flexWrap={"wrap"} gap={1} maxH={"350px"}>
            <InfiniteScroll
              next={() => store.page()}
              hasMore={store.hasMorePagableOwners}
              dataLength={store.pagableOwners.length}
            >
              {store.pagableOwners.map((owner, index) => (
                <Link
                  key={`top-dog-${owner.address}`}
                  onClick={() => store.setSelectedAddress(owner.address)}
                  to={generatePath(`/leaderbork/:address/${SelectedOwnerTab.Wallet}`, {
                    address: owner.address,
                  })}
                >
                  <UserCard
                    rank={index + 1}
                    isSelected={store.selectedOwner?.address === owner.address}
                    onClick={address => store.setSelectedAddress(address)}
                    pixelOwner={owner}
                  >
                    {AppStore.web3?.address === owner.address && (
                      <Typography
                        color={lightOrDarkMode(colorMode, "yellow.100", "gray.300")}
                        variant={TVariant.PresStart12}
                        ml={4}
                      >
                        (you)
                      </Typography>
                    )}
                  </UserCard>
                </Link>
              ))}
            </InfiniteScroll>
          </Flex>
        </Box>
      </Pane>
    </Box>
  );
});

export default TopDogs;
